import { getLiterAmount } from '../formatters/liter-amount'

export function getLiter(amount: string, price: string) {
  if (Number(amount) && Number(price)) {
    return getLiterAmount(Number(amount) / Number(price)) || '-'
  } else return '0'
}
